import Avatar from 'components/Avatar'
import Flex from 'components/Flex'
import LeftArrowIcon from 'components/icons/LeftArrowIcon'
import {
  Address,
  JobDetailsSpan,
  LeftArrowSpan,
  Name,
  NameAdd,
  RoleSpan,
  TopRoleSection,
} from 'modules/Dashboard/Partials/DashboardRoles/Style/style'
import React, { useEffect, useState } from 'react'
import IndividualDriveTable from './Partials/IndividualDriveTable/index'
import { PaddedDiv, SectionWrapper, StyledTab } from './Style/style'

import {
  getCandidateDriveList,
  getDegreeAndDepartMent,
  getRoleMetrics,
  getSpecialisationList,
} from 'modules/Dashboard/actions'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import DriveTabs from './Partials/DriveTabs'
import Metrics from './Partials/Header/Metrics'
import { getIdFormate } from '../../../../utils/getZeroBeforeInt'
const { TabPane } = StyledTab

const ViewIndividualDrive = ({
  driveRolesMetrics,
  getDriveRoleMetrics,
  getDriveRoleCandidatesList,

  getIndidualDriveData,
  driveData,
  createInterview,
  driveInterViewerList,
  getDriveInterviewerList,
  getcollegeList,
  collegeList,
  getCandidateDetails,
  candidateDetails,
  getSingleCandidateInterviewDetails,
  candidateInterviewDetails,
  getGroupDiscussionList,
  getGroupCandidateList,
  groupList,
  groupCandidateList,
  updateInterviewStatus,
  getCities,
  cityList,
  releaseOfferAPI,
  getSingleRoleData,
}) => {
  const params = useParams()
  const dispatch = useDispatch()
  const [selectionType, setSelectionType] = useState('active')

  const changeState = type => {
    if (type === 'active') {
      setStatus('SCHEDULED,SHORTLISTED')
      setFilterStatus('SCHEDULED,SHORTLISTED')
    } else if (type === 'onhold') {
      setStatus('HOLD')
      setFilterStatus('HOLD')
    } else {
      setStatus('REJECTED')
      setFilterStatus('REJECTED')
    }
    setSelectionType(type)
  }
  const navigate = useNavigate()
  let [searchParams, setSearchParams] = useSearchParams()
  const stage = searchParams.get('stage')

  const [selectedRound, setSelectedRound] = useState(stage || 'all_candidates')

  const [selectedRoundType, setSelectedRoundType] = useState('')
  const [currentTab, setCurrentTab] = useState('SCHEDULED,SHORTLISTED')
  const [sortQuery, setSortQuery] = useState('')

  const [scheduleDrawer, setScheduleDrawer] = useState(false)
  const [releaseOffer, setReleaseOffer] = useState(false)
  const [selectedCandidate, setSelectedCandidate] = useState([])
  const [selectedCandidateId, setSelectedCandidateId] = useState([])

  const [isLoading, setIsLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(0)
  const [status, setStatus] = useState('SCHEDULED,SHORTLISTED')
  const [searchValue, setSearchValue] = useState('')
  const [sortBy, setSortBy] = useState('')

  const [candidateRating, setCandidateRating] = useState([])
  const [interviewRound, setInterviewRound] = useState([])
  const [college, setCollege] = useState([])
  const [collegeSearch, setCollegeSearch] = useState('')
  const [checkedKeys, setCheckedKeys] = useState([])
  const [checkedIds, setCheckedIds] = useState([])
  const [filterStatus, setFilterStatus] = useState('SCHEDULED,SHORTLISTED')
  const [filterDatas, setFilterDatas] = useState({})

  const [candidateInfoData, setCandidateInfoData] = useState({})
  const driveID = params?.driveID
  const rolesMetrics = useSelector(state => state?.dashboard?.roleMetrics)
  const candidateDeatils = useSelector(
    state => state?.dashboard?.dashboardDriveCandinateList
  )
  const specialisationList = useSelector(
    state => state?.dashboard?.getSpecialisationListForReport
  )
  const degreeList = useSelector(state => state?.dashboard?.degreeList)
  const singleRoleData = useSelector(state => state?.roles?.singleRoleDetails)
  const [keySpecialisation, setKeySpecialisation] = useState('')

  const [debouncedSpecialisation, setDebouncedSpecialisation] = useState(
    () => keySpecialisation
  )
  const [specialisationValue, setSpecialisationValue] = useState([])

  useEffect(() => {
    dispatch(
      getCandidateDriveList({
        driveID,
        status,
        stage,
        currentPage,
        searchValue,
        checkedIds,
        rolesMetrics,
        filterDatas,
        sortQuery,
        setIsLoading,
      })
    )
  }, [
    params.driveID,
    params?.roleID,
    status,
    stage,
    currentPage,
    searchValue,
    filterDatas,
    sortQuery,
  ])
  useEffect(() => {
    dispatch(getRoleMetrics(params?.driveID, params?.roleID))
    dispatch(getDegreeAndDepartMent(params?.roleID))
  }, [params.driveID, params?.roleID])

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedSpecialisation(keySpecialisation)
    }, 500)
    return () => {
      clearTimeout(timeout)
    }
  }, [keySpecialisation])
  useEffect(() => {
    if (keySpecialisation) {
      dispatch(getSpecialisationList({ setIsLoading, keySpecialisation }))
    }
  }, [debouncedSpecialisation])

  useEffect(() => {
    setSelectedRound(stage || 'all_candidates')
    setInterviewRound([stage || 'all_candidates'])
  }, [stage])

  const handleArrow = () => {
    navigate(-1)
  }

  const filterData = (data, name) =>
    data?.map(item => ({
      label: item?.[name],
      value: item?.[name],
      checked: false,
    }))

  return (
    <SectionWrapper>
      <PaddedDiv column>
        <TopRoleSection>
          <LeftArrowSpan onClick={handleArrow}>
            <LeftArrowIcon />
          </LeftArrowSpan>
          <RoleSpan onClick={handleArrow}>View Drives</RoleSpan>
          <JobDetailsSpan>/</JobDetailsSpan>
          <RoleSpan onClick={handleArrow}>
            {params?.driveID ? getIdFormate(params?.driveID) : ''}
          </RoleSpan>
          <JobDetailsSpan>/</JobDetailsSpan>
          <JobDetailsSpan>Report</JobDetailsSpan>
        </TopRoleSection>
        <Flex centerVertically style={{ padding: '20px' }}>
          {singleRoleData?.corporate?.logo ? (
            <Avatar src={singleRoleData?.corporate?.logo} />
          ) : (
            <Avatar
              background
              size={42}
              IconName={singleRoleData?.corporate?.name?.split('')?.[0] || 'H'}
              font={18}
            />
          )}
          <NameAdd column flexStart>
            <Address>{singleRoleData?.corporate?.name}</Address>
            <Flex row>
              {' '}
              <Name>{singleRoleData?.tittle} &nbsp;&nbsp;</Name>{' '}
            </Flex>
          </NameAdd>
        </Flex>
        <div style={{ padding: '20px' }}>
          <Metrics
            rolesMetrics={rolesMetrics}
            selectedRound={selectedRound}
            setSelectedRound={setSelectedRound}
            setSearchParams={setSearchParams}
            setCurrentPage={setCurrentPage}
            setSelectedCandidateId={setSelectedCandidateId}
            setSelectedCandidate={setSelectedCandidate}
            selectedCandidate={selectedCandidate}
            setCurrentTab={setCurrentTab}
            setStatus={setStatus}
            setFilterStatus={setFilterStatus}
            setSelectionType={setSelectionType}
          />
        </div>

        <DriveTabs
          selected={selectionType}
          selectedType={type => {
            changeState(type)
          }}
          activeCount={candidateDeatils?.activeCount}
          onHold={candidateDeatils?.onHoldCount}
          rejectedCount={candidateDeatils?.rejectedCount}
        />
        <IndividualDriveTable
          scheduleDrawer={scheduleDrawer}
          setScheduleDrawer={setScheduleDrawer}
          candidateDeatils={candidateDeatils}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          setSearchValue={setSearchValue}
          setSortBy={setSortBy}
          sortBy={sortBy}
          isLoading={isLoading}
          candidateRating={candidateRating}
          setCandidateRating={setCandidateRating}
          interviewRound={interviewRound}
          setInterviewRound={setInterviewRound}
          rolesMetrics={rolesMetrics}
          degreeList={degreeList}
          setSearchParams={setSearchParams}
          checkedKeys={checkedKeys}
          setCheckedKeys={setCheckedKeys}
          checkedIds={checkedIds}
          setCheckedIds={setCheckedIds}
          setSelectedCandidateId={setSelectedCandidateId}
          setSelectedCandidate={setSelectedCandidate}
          collegeList={collegeList}
          college={college}
          setCollege={setCollege}
          setCollegeSearch={setCollegeSearch}
          collegeSearch={collegeSearch}
          getCandidateDetails={getCandidateDetails}
          candidateDetails={candidateDetails}
          getSingleCandidateInterviewDetails={
            getSingleCandidateInterviewDetails
          }
          driveId={params?.driveId}
          roleId={params?.roleId}
          candidateInterviewDetails={candidateInterviewDetails}
          updateInterviewStatus={updateInterviewStatus}
          selectedRoundType={selectedRoundType}
          setSelectedRoundType={setSelectedRoundType}
          getGroupCandidateList={getGroupCandidateList}
          groupList={groupList}
          groupCandidateList={groupCandidateList}
          status={status}
          stage={stage}
          candidateInfoData={candidateInfoData}
          setCandidateInfoData={setCandidateInfoData}
          setStatus={setStatus}
          filterStatus={filterStatus}
          setFilterStatus={setFilterStatus}
          getRoleMetrics={getRoleMetrics}
          selectedCandidateId={selectedCandidateId}
          setReleaseOffer={setReleaseOffer}
          releaseOffer={releaseOffer}
          currentTab={currentTab}
          specialisationValue={specialisationValue}
          setSpecialisationValue={setSpecialisationValue}
          specialisationList={filterData(specialisationList?.result, 'name')}
          setKeySpecialisation={setKeySpecialisation}
          keySpecialisation={keySpecialisation}
          setFilterData={setFilterDatas}
          sortQuery={sortQuery}
          setSortQuery={setSortQuery}
        />
      </PaddedDiv>
    </SectionWrapper>
  )
}

export default ViewIndividualDrive
